<template>
    <div>
        <el-tooltip
        v-if="!permissionRosterChecklist || !featureEnabledRosterChecklist"
        placement="top"
        :enterable="false"
        effect="light">
            <div slot="content">
                <template v-if="featureEnabledRosterChecklist">
                    <div>Roster Checklists are currently <span class="font-bold">disabled</span> by your company administrator.</div>
                    <div>They can be enabled in <span class="font-bold">Company Settings</span>.</div>
                </template>
                <template v-else>
                    <div class="font-bold">Roster Checklists are a powerful way to provide task lists for your Associates and Users.</div>
                    <div class="font-bold">Contact Hera Support to upgrade today.</div>
                </template>
            </div>
            <div class="relative cursor-help opacity-50" :class="{'checklist-feature-disabled': !featureEnabledRosterChecklist }">
                <slot></slot>
                <div class="absolute w-full h-full top-0 left-0 zindex1"></div>
            </div>
        </el-tooltip>
        <slot v-else></slot>
    </div>
</template>
<script>
export default {
    computed:{
        featureEnabledRosterChecklist(){
            return this.$store.state.userInfo.tenant.featureEnabledRosterChecklist
        },
        permissionRosterChecklist(){
            return this.$store.state.userInfo.tenant.permissionRosterChecklist
        }
    }
}
</script>
<style scoped>
.zindex1{
    z-index: 10000 !important;
}
</style>